import logo from './image/logo.jpeg';

export default function CortexGroupLandingPage() {
  return (
    <div className="min-h-[100dvh] overflow-hidden bg-black text-white">
      <div className="relative min-h-[100dvh]">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_20%,rgba(0,255,180,0.18),transparent_0%,transparent_28%),radial-gradient(circle_at_78%_12%,rgba(152,255,220,0.12),transparent_0%,transparent_22%),radial-gradient(circle_at_50%_100%,rgba(255,255,255,0.06),transparent_0%,transparent_30%),linear-gradient(to_bottom,rgba(255,255,255,0.02),transparent_20%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.8)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.8)_1px,transparent_1px)] bg-[size:40px_40px] opacity-[0.06] md:bg-[size:64px_64px]" />
        <div className="absolute left-[-25%] top-[8%] h-[260px] w-[260px] rounded-full bg-emerald-400/20 blur-[100px] md:left-[-10%] md:h-[420px] md:w-[420px] md:blur-[120px]" />
        <div className="absolute right-[-20%] top-[10%] h-[220px] w-[220px] rounded-full bg-teal-200/10 blur-[90px] md:right-[-8%] md:h-[320px] md:w-[320px] md:blur-[120px]" />

        <header className="relative z-10 px-4 py-5 sm:px-6 md:px-12 lg:px-20">
          <div className="mx-auto flex max-w-7xl items-center justify-between">
            <div className="flex items-center gap-4">
              <img src={logo} alt="Cortex Group" className="h-9 w-auto object-contain md:h-12" />
            </div>
            <a
              href="#contact"
              className="rounded-full border border-white/15 bg-white/5 px-4 py-2 text-xs text-white/90 backdrop-blur-sm transition hover:border-emerald-300/30 hover:bg-white/10 sm:px-5 sm:py-2.5 sm:text-sm"
            >
              Contact
            </a>
          </div>
        </header>

        <main className="relative z-10 px-4 pb-16 pt-4 sm:px-6 sm:pt-8 md:px-12 md:pb-28 md:pt-14 lg:px-20 lg:pt-16">
          <section className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:items-center lg:gap-14">
            <div className="max-w-4xl">
              <div className="inline-flex items-center rounded-full border border-emerald-300/20 bg-emerald-300/10 px-3 py-2 text-[10px] uppercase tracking-[0.24em] text-emerald-200/80 backdrop-blur-sm sm:px-4 sm:text-[11px] sm:tracking-[0.28em]">
                Swiss Strategic Advisory
              </div>

              <h1 className="mt-6 text-[clamp(2.1rem,11vw,6rem)] font-semibold leading-[0.94] tracking-[-0.04em] text-white sm:mt-8 sm:tracking-[-0.05em]">
                Helping leaders navigate AI and digital assets.
              </h1>

              <p className="mt-6 max-w-2xl text-sm leading-7 text-white/68 sm:mt-8 sm:text-base sm:leading-8 md:text-lg">
                Cortex Group is a Swiss strategic advisory firm serving senior decision-makers, investors and leading
                companies operating across two defining technological shifts: artificial intelligence and digital assets.
              </p>

              <p className="mt-4 max-w-2xl text-sm leading-7 text-white/52 sm:mt-5 sm:text-base sm:leading-8 md:text-lg">
                We provide clear strategic perspective on adoption, positioning, risk, transformation and long-term
                direction - with discretion, precision and senior-level engagement.
              </p>

              <div className="mt-10 flex flex-col gap-4 sm:flex-row">
                <a
                  href="#contact"
                  className="inline-flex w-full items-center justify-center rounded-full bg-emerald-300 px-7 py-3 text-sm font-medium text-black transition hover:opacity-90 sm:w-auto"
                >
                  Request a Private Conversation
                </a>
                <a
                  href="#expertise"
                  className="inline-flex w-full items-center justify-center rounded-full border border-white/15 bg-white/5 px-7 py-3 text-sm font-medium text-white/90 backdrop-blur-sm transition hover:border-emerald-300/30 hover:bg-white/10 sm:w-auto"
                >
                  Explore Expertise
                </a>
              </div>
            </div>

            <div className="relative">
              <div className="absolute -inset-6 rounded-[30px] bg-emerald-300/8 blur-3xl sm:-inset-8 sm:rounded-[36px]" />
              <div className="relative overflow-hidden rounded-[28px] border border-white/10 bg-white/[0.045] p-5 backdrop-blur-xl sm:rounded-[36px] sm:p-7 md:p-8">
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-emerald-300/60 to-transparent" />
                <div className="text-xs uppercase tracking-[0.28em] text-white/40">Core Positioning</div>

                <div className="mt-6 space-y-4">
                  <div className="rounded-[20px] border border-white/10 bg-black/30 p-4 sm:rounded-[24px] sm:p-5">
                    <div className="text-sm text-white/40">Advisory Scope</div>
                    <div className="mt-2 text-xl font-medium text-white">Artificial Intelligence</div>
                  </div>
                  <div className="rounded-[20px] border border-white/10 bg-black/30 p-4 sm:rounded-[24px] sm:p-5">
                    <div className="text-sm text-white/40">Advisory Scope</div>
                    <div className="mt-2 text-xl font-medium text-white">Digital Assets</div>
                  </div>
                  <div className="rounded-[20px] border border-white/10 bg-black/30 p-4 sm:rounded-[24px] sm:p-5">
                    <div className="text-sm text-white/40">Approach</div>
                    <div className="mt-2 text-xl font-medium text-white">Selective, discreet, senior-level</div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="mx-auto mt-16 max-w-7xl sm:mt-20">
            <div className="grid gap-4 md:grid-cols-3">
              <div className="rounded-[24px] border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm sm:rounded-[28px] sm:p-8">
                <div className="text-sm uppercase tracking-[0.22em] text-white/40">Who We Serve</div>
                <div className="mt-5 text-2xl font-semibold tracking-[-0.03em] sm:mt-6 sm:text-3xl">Senior decision-makers</div>
                <p className="mt-4 text-sm leading-7 text-white/58">
                  Founders, CEOs, boards, investors and leadership teams facing strategic technology decisions.
                </p>
              </div>
              <div className="rounded-[24px] border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm sm:rounded-[28px] sm:p-8">
                <div className="text-sm uppercase tracking-[0.22em] text-white/40">What We Deliver</div>
                <div className="mt-5 text-2xl font-semibold tracking-[-0.03em] sm:mt-6 sm:text-3xl">Strategic clarity</div>
                <p className="mt-4 text-sm leading-7 text-white/58">
                  Independent perspective on adoption, risk, positioning and long-term competitive direction.
                </p>
              </div>
              <div className="rounded-[24px] border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm sm:rounded-[28px] sm:p-8">
                <div className="text-sm uppercase tracking-[0.22em] text-white/40">How We Engage</div>
                <div className="mt-5 text-2xl font-semibold tracking-[-0.03em] sm:mt-6 sm:text-3xl">Selective mandates</div>
                <p className="mt-4 text-sm leading-7 text-white/58">
                  A limited number of high-value engagements where judgment, speed and discretion matter.
                </p>
              </div>
            </div>
          </section>

          <section id="expertise" className="mx-auto mt-20 grid max-w-7xl gap-10 sm:mt-24 lg:mt-28 lg:grid-cols-[0.92fr_1.08fr] lg:gap-12">
            <div>
              <div className="text-xs uppercase tracking-[0.3em] text-emerald-200/55">Expertise</div>
              <h2 className="mt-4 max-w-xl text-2xl font-semibold tracking-[-0.03em] text-white sm:mt-5 sm:text-3xl md:text-5xl">
                Clarity where technological complexity meets strategic consequence.
              </h2>
            </div>

            <div className="grid gap-5 md:grid-cols-2">
              <div className="rounded-[22px] border border-white/10 bg-white/[0.03] p-6 sm:rounded-[28px] sm:p-7">
                <div className="text-lg font-medium text-white">AI Strategy</div>
                <p className="mt-4 text-sm leading-7 text-white/58">
                  Understanding where AI creates real leverage, how to approach adoption and how to think clearly
                  beyond hype.
                </p>
              </div>
              <div className="rounded-[22px] border border-white/10 bg-white/[0.03] p-6 sm:rounded-[28px] sm:p-7">
                <div className="text-lg font-medium text-white">Digital Asset Strategy</div>
                <p className="mt-4 text-sm leading-7 text-white/58">
                  Strategic perspective on blockchain infrastructure, tokenized models, market positioning and emerging
                  digital asset opportunities.
                </p>
              </div>
              <div className="rounded-[22px] border border-white/10 bg-white/[0.03] p-6 sm:rounded-[28px] sm:p-7">
                <div className="text-lg font-medium text-white">Executive Advisory</div>
                <p className="mt-4 text-sm leading-7 text-white/58">
                  Support for consequential decisions involving transformation, timing, capital allocation and strategic
                  direction.
                </p>
              </div>
              <div className="rounded-[22px] border border-white/10 bg-white/[0.03] p-6 sm:rounded-[28px] sm:p-7">
                <div className="text-lg font-medium text-white">Private Engagements</div>
                <p className="mt-4 text-sm leading-7 text-white/58">
                  Designed for leaders seeking senior-level advisory relationships rather than commodity consulting.
                </p>
              </div>
            </div>
          </section>

          <section className="mx-auto mt-20 max-w-7xl sm:mt-24">
            <div className="grid gap-4 md:grid-cols-4">
              <div className="rounded-[24px] border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm sm:rounded-[28px] sm:p-7">
                <div className="text-sm uppercase tracking-[0.22em] text-white/40">Trust Signal</div>
                <div className="mt-5 text-2xl font-semibold tracking-[-0.03em] text-white">Swiss structure</div>
                <p className="mt-4 text-sm leading-7 text-white/56">Cortex AG, based in Zug, Switzerland.</p>
              </div>
              <div className="rounded-[24px] border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm sm:rounded-[28px] sm:p-7">
                <div className="text-sm uppercase tracking-[0.22em] text-white/40">Trust Signal</div>
                <div className="mt-5 text-2xl font-semibold tracking-[-0.03em] text-white">Independent judgment</div>
                <p className="mt-4 text-sm leading-7 text-white/56">
                  Clear strategic perspective across AI and digital assets.
                </p>
              </div>
              <div className="rounded-[24px] border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm sm:rounded-[28px] sm:p-7">
                <div className="text-sm uppercase tracking-[0.22em] text-white/40">Trust Signal</div>
                <div className="mt-5 text-2xl font-semibold tracking-[-0.03em] text-white">Selective mandates</div>
                <p className="mt-4 text-sm leading-7 text-white/56">
                  A limited number of private engagements at senior level.
                </p>
              </div>
              <div className="rounded-[24px] border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm sm:rounded-[28px] sm:p-7">
                <div className="text-sm uppercase tracking-[0.22em] text-white/40">Trust Signal</div>
                <div className="mt-5 text-2xl font-semibold tracking-[-0.03em] text-white">Discreet by design</div>
                <p className="mt-4 text-sm leading-7 text-white/56">
                  We do not publicly comment on private client engagements.
                </p>
              </div>
            </div>
          </section>

          <section className="mx-auto mt-20 max-w-7xl sm:mt-24 lg:mt-28">
            <div className="overflow-hidden rounded-[28px] border border-white/10 bg-white/[0.045] p-6 sm:rounded-[36px] sm:p-8 md:p-12 lg:p-14">
              <div className="absolute" />
              <div className="grid gap-10 lg:grid-cols-[1fr_0.8fr] lg:items-center">
                <div>
                  <div className="text-xs uppercase tracking-[0.3em] text-white/40">Perspective</div>
                  <h3 className="mt-4 max-w-3xl text-2xl font-semibold tracking-[-0.03em] text-white sm:mt-5 sm:text-3xl md:text-5xl">
                    Two structural shifts. One strategic imperative.
                  </h3>
                  <p className="mt-5 max-w-2xl text-sm leading-7 text-white/62 sm:mt-6 sm:text-base sm:leading-8">
                    Artificial intelligence and digital assets are reshaping how companies think about value creation,
                    competitive advantage and long-term positioning. Cortex Group helps leaders understand the signal,
                    frame the opportunity and act with precision.
                  </p>
                </div>

                <div className="grid gap-4">
                  <div className="rounded-[20px] border border-emerald-300/15 bg-black/30 p-5 sm:rounded-[24px] sm:p-6">
                    <div className="text-sm uppercase tracking-[0.22em] text-white/38">Principle</div>
                    <div className="mt-3 text-xl font-medium text-white">Independent judgment</div>
                  </div>
                  <div className="rounded-[20px] border border-emerald-300/15 bg-black/30 p-5 sm:rounded-[24px] sm:p-6">
                    <div className="text-sm uppercase tracking-[0.22em] text-white/38">Principle</div>
                    <div className="mt-3 text-xl font-medium text-white">Discretion by design</div>
                  </div>
                  <div className="rounded-[20px] border border-emerald-300/15 bg-black/30 p-5 sm:rounded-[24px] sm:p-6">
                    <div className="text-sm uppercase tracking-[0.22em] text-white/38">Principle</div>
                    <div className="mt-3 text-xl font-medium text-white">Senior-level engagement</div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="contact" className="mx-auto mt-20 max-w-5xl text-center sm:mt-24 lg:mt-28">
            <div className="text-xs uppercase tracking-[0.3em] text-emerald-200/55">Contact</div>
            <h2 className="mt-4 text-2xl font-semibold tracking-[-0.03em] text-white sm:mt-5 sm:text-3xl md:text-5xl">
              Private conversations for leaders shaping what comes next.
            </h2>
            <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-white/60 sm:mt-6 sm:text-base sm:leading-8 md:text-lg">
              Cortex Group works with a limited number of companies, investors and senior decision-makers seeking
              strategic counsel on AI and digital assets.
            </p>
            <div className="mt-6 text-sm leading-7 text-white/45">
              Cortex AG
              <br />
              Zug, Switzerland
            </div>

            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <a
                href="https://calendar.app.google/tpZ8cfm8mN9bUmpo9"
                className="inline-flex w-full items-center justify-center rounded-full bg-emerald-300 px-7 py-3 text-sm font-medium text-black transition hover:opacity-90 sm:w-auto"
              >
                Request a Private Conversation
              </a>
            </div>
          </section>
        </main>

        <footer className="relative z-10 border-t border-white/10 px-6 py-8 md:px-12 lg:px-20">
          <div className="mx-auto flex max-w-7xl flex-col gap-3 text-center text-sm text-white/42 md:flex-row md:items-center md:justify-between md:text-left">
            <div>Cortex AG - Zug, Switzerland</div>
            <div>Swiss Strategic Advisory for AI and Digital Assets</div>
          </div>
        </footer>
      </div>
    </div>
  );
}
